import {
  Component,
  Input,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslatePipe } from '@app/pipes/translate.pipe';
import { ExternalService } from '@app/services/http/external.service';
import { SafePipe } from '@app/pipes/safe';

@Component({
  selector: 'app-hh-seo-desc',
  templateUrl: './hh-seo-dec.html',
  styleUrls: ['./hh-seo-desc.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [TranslatePipe, SafePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [ExternalService],
})
export class HhSeoDescComponent {
  @Input() hhSeoDesc?: string;
  @Input() hhSeoTitle?: string;
  currentParams?: string;
  constructor(
    public dialog: MatDialog,
    private router: Router,
    public externalService: ExternalService,
  ) {}

  openAuthDialog() {
    this.currentParams = this.router.url;
    return this.externalService.goToSignup();
  }
}
